var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.28 -247.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 25.28,
    y: 255.97,
    width: 3.12,
    height: 5.42
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 31.22,
    y: 251.59,
    width: 3.12,
    height: 9.79
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 37.15,
    y: 247.84,
    width: 3.12,
    height: 13.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDashboard);
export default __webpack_public_path__ + "static/media/sidebar_dashboard.1b305cb693e72a1115246f6d170111bd.svg";
export { ForwardRef as ReactComponent };